var _effectorFileName = "/builds/gmini/front-common/src/forge-viewer/service/selectionService.ts";
import { createEvent, restore } from 'effector';
export function createSelectionService() {
  var resetSelectedElements = createEvent({
    name: "resetSelectedElements",
    sid: "-lcyoch"
  });
  var setSelectedElements = createEvent({
    name: "setSelectedElements",
    sid: "iy83ki"
  });
  var selectedElements$ = restore(setSelectedElements, null, {
    name: "selectedElements$",
    sid: "-66uzjv"
  }).reset(resetSelectedElements);
  return {
    selectedElements$: selectedElements$,
    resetSelectedElements: resetSelectedElements,
    setSelectedElements: setSelectedElements
  };
}
export var selectionService = createSelectionService();